import React from "react";
import { useSelector } from "react-redux";
import SummaryCards from "./SummaryCards";
import TransactionsTable from "../TransactionsTable";
import TransactionHeader from "./TransactionHeader";
import { DateCTA, Typography } from "components";

const AdminTransactions = ({ handleDateModalOpen }) => {
  const { params } = useSelector((state) => ({
    params: state.transactionsReducer.params,
  }));

  const { dateFrom, dateTo } = params || {};

  return (
    <div>
      <Typography
        variant="heading3"
        className={"mb-3"}
        state="primary"
        component="h3"
      >
        Transactions
      </Typography>
      <TransactionHeader />
      <div className="d-flex align-items-center cursor-pointer">
        <Typography variant="caption0">Choose Date:</Typography> &nbsp;
        <DateCTA onClick={() => handleDateModalOpen()} /> &nbsp; &nbsp;
        {dateFrom && dateTo && (
          <Typography variant="caption2" state="primary" className={"mt-2"}>
            {dateFrom} to {dateTo}
          </Typography>
        )}
      </div>
      <SummaryCards />
      <TransactionsTable isDashboardTransactions={false} />
    </div>
  );
};

export default AdminTransactions;
